// extracted by css-extract-rspack-plugin
module.exports =  {"quiz":"bacaae3ada"};